export const ITipScreenViewModelType = Symbol('ITipScreenViewModel');
